import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const Valor1500UitFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onSelectKeyDown = React.useCallback(e => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      e.preventDefault()
      KeyEventUtil.leaveOnKeyEvent('input-importe')
    }
  }, [])

  return (
    <Form.Group>
      <Form.Label text='1500 UIT' htmlFor='select-valor1500Uit' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='valor1500Uit'>
          {({ field }) => (
            <Form.Select {...field} id='select-valor1500Uit' isInvalid={iTouched && iError} disabled={fIsSubmitting} onKeyDown={onSelectKeyDown}>
              <option value=''>Seleccionar</option>
              <option value='1'>1 - MERCADERIA, MATERIA PRIMA, SUMINISTRO, ENVASES Y EMBALAJES</option>
              <option value='2'>2 - ACTIVO FIJO</option>
              <option value='3'>3 - OTROS ACTIVOS NO CONSIDERADOS EN LOS NUMERALES 1 Y 2</option>
              <option value='4'>
                4 - GASTOS DE EDUCACIÓN, RECREACIÓN, SALUD, CULTURALES, REPRESENTACIÓN, CAPACITACIÓN, DE VIAJE, MANTENIMIENTO DE VEHICULO Y PREMIOS
              </option>
              <option value='5'>5 - OTROS GASTOS NO INCLUIDOS EN EL NUMERAL 4</option>
            </Form.Select>
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(Valor1500UitFormGroup)
